import React from 'react'
import contactService from '../../../Services/contactService';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import RelatedContactItem from '../../../Domain/RelatedContactItem';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';


class RelatedContacts extends React.Component 
{
    static defaultProps = {
        contactOwnId: null,
        clientId: 0,
    };

    constructor(props)
    {
        super(props);
        this.state = {
            searchItem: {},
            orderDirection: OrderDirectionsEnum.Asc,
            orderBy: "id"
        };
    }

    static clickOnContactId(id) 
    {
        alert(id);
    }

    
    render() 
    {
        return (
            <div className="contentwrapper">
                <TabOfDataTable
                    type={RelatedContactItem}
                    shownPanel={this.state.shownPanel}
                    serviceFunction={() => contactService.GetRelatedContacts(this.props.contactOwnId)}
                    convertDBItemsFunction={contactService.ConvertDBItems}
                    orderDirection={this.state.orderDirection}
                    orderBy={this.state.orderBy}
                    searchItem={this.state.searchItem}
                    showSearchStrip={false}
                    searchParamsType={null}
                    clickOnStartSearch={null}
            errorCode="RC46"
            />
            </div>
        );
    }
}


export default RelatedContacts;
